import { IconProps } from "../../utils/global-types/global-types";

const DataSplitIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M10 7.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25M10 3.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25M10 11.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25M2 7.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
    ></path>
    <path
      fill="currentColor"
      d="M9.5 6.375c.205 0 .375-.17.375-.375a.38.38 0 0 0-.375-.375H5.875V3.5c0-.79.335-1.125 1.125-1.125h2.5c.205 0 .375-.17.375-.375a.38.38 0 0 0-.375-.375H7c-1.21 0-1.875.665-1.875 1.875v2.125H2.5A.38.38 0 0 0 2.125 6c0 .205.17.375.375.375h2.625V8.5c0 1.21.665 1.875 1.875 1.875h2.5c.205 0 .375-.17.375-.375a.38.38 0 0 0-.375-.375H7c-.79 0-1.125-.335-1.125-1.125V6.375z"
    ></path>
  </svg>
);

export default DataSplitIcon;
